var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import qs from 'qs';
import { mergeDeepRight } from 'ramda';

export var searchParameters = {
  hitsPerPage: 6
};

var createURL = function createURL(state) {
  return '?' + qs.stringify(state);
};

export var searchStateToUrl = function searchStateToUrl(props, searchState) {
  return searchState ? '' + props.location.pathname + createURL(searchState) : '';
};
var urlToSearchState = function urlToSearchState(location) {
  return qs.parse(location.search.slice(1));
};

export default (function (InstantSearch) {
  return function (_React$Component) {
    _inherits(InstantSearchRouted, _React$Component);

    function InstantSearchRouted(props) {
      _classCallCheck(this, InstantSearchRouted);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.state = {
        searchState: urlToSearchState(props.location)
      };
      _this.onSearchStateChange = _this.onSearchStateChange.bind(_this);
      _this.updateBrowserUrl = _this.updateBrowserUrl.bind(_this);
      _this.resetBrowserUrl = _this.resetBrowserUrl.bind(_this);
      return _this;
    }

    InstantSearchRouted.prototype.onSearchStateChange = function onSearchStateChange(searchState) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          clearAll = _ref.clearAll;

      if (clearAll) {
        return this.resetBrowserUrl();
      }
      var nextState = mergeDeepRight(this.state.searchState, searchState);
      this.setState({ searchState: nextState });
      this.updateBrowserUrl(nextState);
    };

    InstantSearchRouted.prototype.updateBrowserUrl = function updateBrowserUrl(searchState) {
      var updatedUrl = searchStateToUrl(this.props, searchState);
      this.props.history.push(updatedUrl, searchState);
    };

    InstantSearchRouted.prototype.resetBrowserUrl = function resetBrowserUrl() {
      return this.props.history.push('/');
    };

    InstantSearchRouted.prototype.render = function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return React.createElement(
        InstantSearch,
        _extends({
          searchState: this.state.searchState,
          onSearchStateChange: this.onSearchStateChange,
          createURL: createURL
        }, props),
        children
      );
    };

    return InstantSearchRouted;
  }(React.Component);
});